import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import './prototypes.js'
import store from './store'
import API from './api/index.js'

// Add global error handlers
function setupGlobalErrorHandlers(api) {

  const sendErrorToServer = async (errorDetails) => {
    try {
      if (errorDetails && errorDetails.message) {
        const msg = String(errorDetails.message);
        if (msg.includes('messaging/unsupported-browser') || msg.includes('unsupported-browser')) {
          return; // Ignore Firebase messaging unsupported browser warning/error
        }
      }

      await fetch('/api/log-client-error', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(errorDetails)
      })
    } catch (apiError) {
      console.error('Failed to send error to server:', apiError)
    }
  }

  window.onerror = function (message, source, lineno, colno, error) {
    console.error('Global error caught:', message, source, lineno, colno, error)
    sendErrorToServer({
      type: 'onerror',
      message,
      source,
      lineno,
      colno,
      stack: error?.stack || null
    })
  }

  window.onunhandledrejection = function (event) {
    console.error('Unhandled promise rejection:', event.reason)
    sendErrorToServer({
      type: 'onunhandledrejection',
      message: event.reason?.message || String(event.reason),
      stack: event.reason?.stack || null
    })
  }
}

setupGlobalErrorHandlers()

Promise.all([
  store.auth(),
  fetch('/api', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'endpoint': '/get-maintenance-status' }
  }).then(res => (res.ok ? res.json() : null)).catch(() => null)
])
  .then(([auth, maintenanceData]) => {
    const maintenance = maintenanceData
      ? {
          active: !!maintenanceData.maintenance,
          message: maintenanceData.message || '',
          loading: false
        }
      : { active: false, message: '', loading: false }

    const { redirectionURL, storeData } = auth || {}
    const isAppAdmin = storeData && storeData.users && storeData.users.some(u => u.roleID === 'app-admin')

    // If maintenance is active and not App Admin, stay on current page to display Maintenance Screen
    if (redirectionURL && (!maintenance.active || isAppAdmin)) {
      window.open(redirectionURL, "_self")
    } else {

      const UAParser = require('ua-parser-js')
      const info = new UAParser().setUA(navigator.userAgent).getResult()

      const deviceInfo = {
        isMobileDevice: info.os.name == "Android" || info.os.name == "iOS",
        os: info.os.name,
        browser: info.browser.name,
        isChrome: info.browser.name == "Chrome",
        isDev: window.location.hostname == "localhost",
        appInstalled: !!window.matchMedia('(display-mode: standalone)').matches,
      }

      const authData = storeData ? {
        store: storeData,
        user: storeData.users[storeData.index],
        users: storeData.users,
        index: storeData.index
      } : null

      const initData = {
        storeData,
        deviceInfo,
        apiClient: new API(storeData),
        auth: authData,
        maintenance
      }

      ReactDOM.render(
        <React.StrictMode>
          <App initData={initData} />
        </React.StrictMode>,
        document.getElementById('root')
      )
    }
  })
  .catch(error => {
    alert(error)
  })